import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HrPageComponent } from './components/hr-page/hr-page.component';
import { AdminHrComponent } from './components/admin-hr/admin-hr.component';
import { AdminGuard } from 'src/app/services/admin.guard';

const routes: Routes = [
  {
    path: ':name', component: HrPageComponent, data: { title: '' }
  },
  {
    path: '',canActivate:[AdminGuard],  component: AdminHrComponent, data: { title: '' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HrRoutingModule { }
